import { FormControl, FormGroup } from '@angular/forms';
import { PropertyMetadata } from '../../../properties/property-types';
import { RegisterElement } from '../../element-decorator';
import { PolygonMapItem } from '../polygon-map-item';

@RegisterElement()
export class Elevator extends PolygonMapItem {
    public override TypeName: string = "Elevator";
    public override ParentType: string | null = "ParkingLevel";
    public override ParentFormGroupName: string | null = "MapItems";
    
    constructor(formGroup: FormGroup) {
        super(formGroup, "Elevator");
        
        if (!formGroup.contains('Name')) {
            formGroup.addControl('Name', new FormControl(''));
        }
        if (!formGroup.contains('Capacity')) {
            formGroup.addControl('Capacity', new FormControl(8)); // 8 person default
        }
        if (!formGroup.contains('DoorPosition')) {
            formGroup.addControl('DoorPosition', new FormControl('front'));
        }
        
        if(formGroup.contains('StrokeColor'))
            this.OutlineColor = '#' + formGroup.get('StrokeColor')?.value;
        else
            this.OutlineColor = "#555555";
        if(formGroup.contains('FillColor'))
            this.FillColor = '#' + formGroup.get('FillColor')?.value;
        else
            this.FillColor = "#666666";
    }

    public override getPropertyMetadata(): PropertyMetadata[] {
        return [
            {
                formControlName: 'Name',
                displayName: 'Elevator Name',
                inputType: { type: 'text' },
                order: 1,
                category: 'General'
            },
            {
                formControlName: 'Capacity',
                displayName: 'Capacity (persons)',
                inputType: { type: 'number' },
                order: 2,
                category: 'Properties'
            },
            {
                formControlName: 'DoorPosition',
                displayName: 'Door Position',
                inputType: { 
                    type: 'select',
                    options: [
                        { value: 'front', label: 'Front' },
                        { value: 'rear', label: 'Rear' },
                        { value: 'both', label: 'Both Sides' }
                    ]
                },
                order: 3,
                category: 'Properties'
            }
        ];
    }

    public override default(): Elevator {
        this.points = [
            { x: 0, y: 0 },
            { x: 2.1, y: 0 },    // Standard elevator width
            { x: 2.1, y: 2.1 },  // Square for typical elevator
            { x: 0, y: 2.1 }
        ];
        return this;
    }

    public override clone(): Elevator {
        return new Elevator(this.formGroup);
    }

} 
